import {gsap, Linear} from "gsap";
import {HTH} from "../HTH";
import {HTHGameConfig} from "../HTHGameConfig";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {CustomWiggle} from "gsap/dist/CustomWiggle";

export interface ISymbolData {
    symName: string,
    symSize: number,
    id: number
    reelId: number,
    spinPosition: number

}

export enum HTHSymbolStates {
    NORMAL,
    WIN_HIGHLIGHT,
    WIN_EXPLODE,
    NO_WIN,
    AVASPLIT,
    LANDING,
    EXPAND,
    NUDGE,
    BLANK,
    MAX_WIN,
}

export class HTHSymbol extends PIXI.Container {
    private _name: string;
    private _state: HTHSymbolStates;
    private _isWild: boolean = false;
    private _isAvaSplitTarget: boolean;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super();

        let symbolName: string = symbolData.symName;
        if (symbolName.indexOf("_W") > 0) {
            symbolName = symbolName[0] + symbolName[1];
            this._isWild = true;
        }
        this.name = symbolName;
        this._isRemoved = false;

        this._name = symbolName;
        if (symbolName == undefined) {
            debugger;
        }

        this._isSpecialSymbol = this.checkSpecialSymbol(this._name);
        this._isNormalSymbol = this.checkNormalSymbol(this._name);
        this._isEnhancerSymbol = this.checkEnhancerSymbol(this._name);

        this._id = symbolData.id;
        this._reelId = symbolData.reelId;
        this._symSize = symbolData.symSize;
        this._isAvaSplitTarget = false;
        this._spinPosition = symbolData.spinPosition;

    }

    private _spinPosition: number;

    get spinPosition(): number {
        return this._spinPosition;
    }

    // private _splitHighlight: TimelineSprite | null = null;

    set spinPosition(value: number) {
        this._spinPosition = value;
    }

    private _participatedInPotentialWin: boolean;

    get participatedInPotentialWin(): boolean {
        return this._participatedInPotentialWin;
    }

    set participatedInPotentialWin(value: boolean) {
        this._participatedInPotentialWin = value;
    }

    private _id: number = -1;

    public get id(): number {
        return this._id;
    }

    public set id(value: number) {
        this._id = value;
    }

    private _reelId: number = -1;

    public get reelId(): number {
        return this._reelId;
    }

    private _isRemoved: boolean = false;

    public get isRemoved(): boolean {
        return this._isRemoved;
    }

    public set isRemoved(value: boolean) {
        this._isRemoved = value;
    }

    private _symSize: number;

    public get symSize(): number {
        return this._symSize;
    }

    public set symSize(value: number) {
        this._symSize = value;
    }

    private _isEnhancerSymbol: boolean;

    public get isEnhancerSymbol(): boolean {
        return this._isEnhancerSymbol;
    }

    public set isEnhancerSymbol(value: boolean) {
        this._isEnhancerSymbol = value;
    }

    private _isSpecialSymbol: boolean;

    public get isSpecialSymbol() {
        return this._isSpecialSymbol;
    }

    public set isSpecialSymbol(value: boolean) {
        this._isSpecialSymbol = value;
    }

    private _isNormalSymbol: boolean;

    public get isNormalSymbol() {
        return this._isNormalSymbol;
    }

    public set isNormalSymbol(value: boolean) {
        this._isNormalSymbol = value;
    }

    public get symName(): string {
        return this._name;
    }

    public set symName(value: string) {
        this._name = value;
    }

    public get symbolState(): HTHSymbolStates {
        return this._state;
    }

    public set symbolState(setState: HTHSymbolStates) {
        this._state = setState;
    }

    public get avaSplitTarget(): boolean {
        return this._isAvaSplitTarget;
    }

    public set avaSplitTarget(value: boolean) {
        this._isAvaSplitTarget = value;
    }

    public removeAndDestroy(): void {
    }

    public playInitialWin(): void {
        if (!this._isEnhancerSymbol) {
            this._isRemoved = true;
            if (this && this.parent) {
                this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this._reelId].reelView.reelLayers.winLayer);
            }
        }

    }

    public playInitialWinEB(): void {
        this._isRemoved = true;
        if (this && this.parent) {
            this.movetoParticularMaskedLayer(HTH.reelArea.allReels[this._reelId].reelView.reelLayers.winLayer);
            this.position.set(0, 3 * HTHGameConfig.symbolHeight)
        }
    }

    public avasplitFireEffect(): gsap.core.Timeline {
        const fireTl: gsap.core.Timeline = gsap.timeline();
        let fireFrames: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("avaSplitEffect")));

        //HTHHelper.copyLocalPosition(fireFrames, this);
        fireFrames.position.set(0, 0);
        fireFrames.anchor.set(0.5, 0.5);
        fireFrames.blendMode = PIXI.BLEND_MODES.ADD;
        fireFrames.name = "AvaSplitEffect";
        fireFrames.visible = false;
        this.addChild(fireFrames);
        //console.log(fireFrames.totalDuration);
        fireTl.add(<gsap.core.Timeline><unknown>fireFrames.getAnimationAutoShowHide(), 0);
        fireTl.add(() => {
            this.removeChild(fireFrames);
        });

        return fireTl;
    }

    public destroyForNudge(): void {
        if (this && this.parent) {
            if (!this._isEnhancerSymbol) {
                this.removeAndDestroy();
            }
        }

    }

    public explode(): gsap.core.Timeline {
        let explodeTl: gsap.core.Timeline = gsap.timeline();
        return explodeTl;
    }

    public highlight(): gsap.core.Timeline {
        let highlightTl: gsap.core.Timeline = gsap.timeline();
        return highlightTl;
    }

    public playPotentialWinHighlight(delay: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const sprite: PIXI.Sprite = new PIXI.Sprite(HTH.assetLoader.getTextures("potential_xway_win/potential_win_1")[0]);
        this.participatedInPotentialWin = true;
        tl.add(() => {
            this.addChild(sprite);
            sprite.alpha = 0;
            sprite.position.set(0, 2);
            sprite.anchor.set(0.5, 0.5);
        }, 0);
        tl.to(sprite, {alpha: 1, duration: 0.1})
        tl.to(sprite, {alpha: 0, duration: 0.1}, delay - 0.1);
        tl.add(() => {
            this.participatedInPotentialWin = false;
            this.removeChild(sprite);
            sprite.destroy();
        })
        return tl;
    }

    public getStateAnimation(state: HTHSymbolStates = HTHSymbolStates.NORMAL, duration: number = 0): gsap.core.Timeline {

        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
        });
        return tl;
    }

    public removalExplode(): gsap.core.Timeline {
        const remExTL: gsap.core.Timeline = gsap.timeline();
        return remExTL;
    }

    public addSplitHighlight(): gsap.core.Timeline {
        const lightTL: gsap.core.Timeline = gsap.timeline();
        const splitHighlight = new TimelineSprite(HTH.assetLoader.getTextures("xSplitHighlightEffect"));

        lightTL.add([
            () => {
                splitHighlight.blendMode = PIXI.BLEND_MODES.ADD;
                splitHighlight.anchor.set(0.5, 0.5);
                this.addChild(splitHighlight);
                splitHighlight.show();
                splitHighlight.playLoop();
            },
        ], 0);
        lightTL.to(this, {duration: 0.25});
        lightTL.to(splitHighlight, {alpha: 0, duration: 0.15});
        lightTL.add(() => {
            splitHighlight.stopLoop();
            splitHighlight.hide();
            this.removeChild(splitHighlight);
        })
        return lightTL;
    }


    public addSplitEffect(size: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        return tl;
    }

    public addSymbolMultiplier(): void {

    }

    public splitMultiplier(size?: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        return tl;
    }

    public animationChange(animName: string): gsap.core.Timeline {
        const tl = gsap.timeline();
        return tl;
    }


    public popOutAnimation(): gsap.core.Timeline {
        const popTl: gsap.core.Timeline = gsap.timeline();
        popTl.to(this.scale, {x: 0.9, y: 0.9, duration: 0.333});
        popTl.to(this.scale, {x: 1.4, y: 1.4, duration: 0.033});
        popTl.to(this.scale, {x: 0.9, y: 0.9, duration: 0.132});
        popTl.to(this.scale, {x: 1, y: 1, duration: 0.033});
        return popTl;

    }

    public shakeAnimation(): gsap.core.Timeline {
        const shakeTl: gsap.core.Timeline = gsap.timeline(),
            x = `${Math.random() > 0.5 ? "-" : "+"}=2`,
            y = `${Math.random() > 0.5 ? "-" : "+"}=3`,
            wiggleEffect = CustomWiggle.create("symShakeWiggle1", {
                wiggles: 50,
                amplitudeEase: Linear.easeNone,
                timingEase: Linear.easeNone,
            });

        shakeTl.to(this.position, {
            duration: 0.5,
            x: x,
            ease: wiggleEffect
        });
        return shakeTl;
    }

    public movetoParticularMaskedLayer(layer: PIXI.Container): void {
        layer.addChild(this);
    }

    protected checkSpecialSymbol(checkName: string): boolean {
        return (checkName.indexOf("M") === -1 && checkName.indexOf("L") === -1);
    }

    protected checkNormalSymbol(checkSymName: string): boolean {
        return (checkSymName[0] === "L" || checkSymName[0] === "M");
    }

    protected getWinEffectAnim(): TimelineSprite {
        let ts: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("winBlast")));
        ts.position.set(0, 0);
        ts.anchor.set(0.5, 0.5);
        ts.blendMode = PIXI.BLEND_MODES.ADD;
        //  ts.pivot.set(-8, -20);
        ts.name = "WinBlast";
        ts.visible = false;
        this.addChild(ts);
        return ts;
    }

    protected getRemBlastAnim(): TimelineSprite {
        let ts: TimelineSprite = new TimelineSprite((HTH.assetLoader.getTextures("removalWildBlastEffect")));
        ts.position.set(0, 0);
        ts.anchor.set(0.5, 0.5);
        ts.blendMode = PIXI.BLEND_MODES.ADD;
        //  ts.pivot.set(-8, -20);
        ts.name = "RWEffect";
        ts.visible = false;
        this.addChild(ts);
        return ts;
    }

    protected getWinHighlightAnim(): TimelineSprite {
        let ts: TimelineSprite = new TimelineSprite(HTH.assetLoader.getTextures("winHighlight"));
        ts.position.set(0, 0);
        ts.anchor.set(0.5, 0.5);
        ts.blendMode = PIXI.BLEND_MODES.ADD;
        ts.scale.set(1, 1);
        ts.visible = false;
        ts.name = "winHighlight";
        this.addChild(ts);
        return ts;
    }

    private checkEnhancerSymbol(nameToCheck: string): boolean {
        if (nameToCheck === "EB" || nameToCheck === "SA") {
            return true;
        }
        return false;
    }


}